import { useEffect, useState } from 'react';
import { TrendingUp, Award, Share2, Users, ChevronUp, Search } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './referrals.css'; // We'll define custom CSS separately
import { useDispatch, useSelector } from 'react-redux';
import { MdOutlineContentCopy } from 'react-icons/md';
import { CgArrowLongRightR } from 'react-icons/cg';
import { LiaMedalSolid } from 'react-icons/lia';
import { IoIosArrowDropright } from 'react-icons/io';
import ReferralDetails from './ReferralDetails';
import { toast } from 'react-toastify';
import { referralLeaderboard, refreshUserDetails, retrieveReferrals } from '../../../actions/user';
import Pagination from '../../../components/Pagination/Pagination';
import { formatLabel } from '../../../actions/payments';
import { HiOutlineCheckCircle } from "react-icons/hi2";

export default function ReferralDesign() {
    const userDetails = useSelector((state) => state.user.user);
    const isLoggedIn = userDetails !== null && userDetails.email;
    const [leaderboardData, setLeaderboardData] = useState([]);
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('all');
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [copied, setCopied] = useState(false);
    const referralCode = userDetails?.referral_code?.code;
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const referralLink = referralCode ? `${baseUrl}/getstarted?ref=${referralCode}` : `${baseUrl}/getstarted`;
    const [page, setPage] = useState(1);
    const perPage = 10;
    const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });
    const [filteredData, setFilteredData] = useState([])
    const [currentReferral, setCurrentReferral] = useState(null);
    const [toggleReferral, setToggleReferral] = useState(false);

    const handleCopyLink = () => {
        navigator.clipboard.writeText(referralLink);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 5000);
    };

    const fetchReferrals = async (page = 1) => {
        setLoading(true);
        // console.log(page)
        try {
            const responseData = await retrieveReferrals(perPage, page);
            const paginationInfo = responseData.pagination || {};
            console.log(responseData.data)
            setFilteredData(responseData.data || [])
            setPagination(paginationInfo);
            setPage(page);
        } catch (error) {
            // console.error('Error fetching leaderboard data:', error);
            toast.error('Failed to fetch leaderboard data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReferrals();
    }, []);

    useEffect(() => {
      if (isLoggedIn) {
        refreshUserDetails(dispatch);
      }
    }, [isLoggedIn]);
    

  return (
    <section className="leaderboard_pg">
        <div className="leaderboard-container">
            <div className="header-gradient">
                <div className="container py-1">
                    <h6>Your referral code: <span className="text-white">{referralCode}</span></h6>

                    <div className="text-center my-1 d-flex align-items-center justify-content-start gap-3">
                        <button
                            className="btn btn-info btn-sm share-btn"
                            onClick={() => {
                                if (navigator.share) {
                                navigator.share({
                                    title: 'Join me on CardPlot!',
                                    text: 'Use my referral link to get started:',
                                    url: referralLink,
                                }).catch((err) => {
                                    // console.error('Error sharing:', err);
                                });
                                } else {
                                    handleCopyLink();
                                    toast.warning('Sharing is not supported on this browser. Link copied to clipboard instead!');
                                }
                            }}
                            >
                            <Share2 size={18} className="me-2" />
                            Share Your Referral link
                        </button>
                        <div className="d-flex align-items-center gap-2">
                            {/* <span className="mb-0">Copy</span> */}
                            <div className="position-relative">
                                <div className="copy-icon" title='Copy Referral Link'>
                                    <div className="position-relative">
                                        <MdOutlineContentCopy role="button" size={20} color="#fff" onClick={handleCopyLink} />
                                        {/* Tooltip */}
                                        {copied && (
                                            <div className="copy-tooltip text-white p-2 rounded small">
                                                Copied!
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row mt-4">
                        <div className="col-md-3">
                            <ReferralStatItem 
                                title="Total Referrals"
                                value={userDetails?.referral_count}
                            />
                        </div>
                        <div className="col-md-3">
                            <ReferralStatItem 
                                title="Active Referrals"
                                value={userDetails?.referral_count}
                            />
                        </div>
                        {/* <div className="col-md-3">
                            <ReferralStatItem 
                                title="Completed Tasks"
                                value={userDetails?.referral_count}
                            />
                        </div> */}
                        <div className="col-md-3">
                            <ReferralStatItem 
                                title="Points Earned"
                                value={userDetails?.referral_points}
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="container py-4">
                <div className="row mb-4">
                    <div className="col-md-6 mb-3 mb-md-0">
                        <div className="btn-group d-none" role="group" aria-label="Time period filters">
                            <button type="button" 
                                className={`btn ${activeTab === 'all' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                onClick={() => setActiveTab('all')}
                            >
                                All
                            </button>
                            <button type="button" 
                                className={`btn ${activeTab === 'weekly' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                onClick={() => setActiveTab('weekly')}
                            >
                                Weekly
                            </button>
                            <button type="button" 
                                className={`btn ${activeTab === 'friends' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                onClick={() => setActiveTab('friends')}
                            >
                                Friends
                            </button>
                        </div>
                    </div>
                    
                    {/* <div className="col-md-6">
                        <div className="input-group">
                            <span className="input-group-text bg-white">
                                <Search size={18} />
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search users or ref_id"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div> */}
                </div>
                
                <div className="card shadow-sm mb-4">
                    <div className="table-responsive">
                        <table className="table table-hover leaderboard-table mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className='text-secondary'>User</th>
                                    <th className="text-center text-secondary">Points Earned</th>
                                    <th className="text-center text-secondary">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>                        
                                ) : (
                                    filteredData.map((referral) => (<>
                                        <tr key={referral.id} onClick={() => {
                                            setCurrentReferral(referral);
                                            setToggleReferral(currentReferral?.id == referral.id ? !toggleReferral : true)
                                        }}>
                                            <td className="text-left" style={{borderBottomWidth: currentReferral?.id == referral.id ? 0 : 1}}>
                                                <div className="flex align-items-left">
                                                    <div className="me-2">
                                                        {referral.user.business_name || referral.user.username || referral.user.full_name }
                                                    </div>
                                                    <div className="text-sm text-grey">{referral.user.email}</div>
                                                </div>
                                            </td>
                                            <td className="text-center text-primary fw-bold" style={{borderBottomWidth: currentReferral?.id == referral.id ? 0 : 1}}>
                                                {referral.points_earned.toLocaleString()}
                                            </td>
                                            <td className="text-center" style={{borderBottomWidth: currentReferral?.id == referral.id ? 0 : 1}}>
                                                <span className={`py-1 px-2 text-sm status-${referral.user.status == 'active' ? 'completed' : 'failed'}`}>
                                                    {formatLabel(referral.user.status)}
                                                </span>
                                            </td>
                                        </tr>
                                        {referral.id == currentReferral?.id && toggleReferral && <tr>
                                            <td colSpan={3}>
                                                <div className="completed-tasks">
                                                    <h5 className="mb-3">Completed Tasks</h5>
                                                    {currentReferral?.tasks.map((task, index) => <CompletedTasks 
                                                        key={index}
                                                        name={task.name}
                                                        date={task.date}
                                                        points={task.points}
                                                    />)}
                                                </div>
                                            </td>
                                        </tr>}
                                    </>))
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex justify-content-end my-4 mx-2">
                        <nav>
                            <Pagination
                                currentPage={page}
                                totalPages={pagination.last_page}
                                onPageChange={(pageNum) => fetchReferrals(pageNum)}
                            />
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
}

const ReferralStatItem = ({title, value}) => {
    return (
        <div className="stat-card">
            <div className="d-flex align-items-center">
                <Users className="me-2" size={20} />
                <h6 className="fw-semibold mb-0"> {title} </h6>
            </div>
            <p className="fs-1 fw-bold mb-0">{value}</p>
        </div>
    )
}

const CompletedTasks = ({name, date, points}) => {
    return (
        <div className="d-flex align-items-center justify-content-between py-3 border-bottom">
            <div className="d-flex align-items-start gap-2">
                <HiOutlineCheckCircle
                    className="text-success mt-1"
                    size={20}
                />

                <div>
                    <h6 className="mb-1">{name}</h6>
                    <small className="text-muted">
                        {date}
                    </small>
                </div>
            </div>

            <span className="badge bg-success-subtle text-success rounded-pill">
                +{points} pts
            </span>
        </div>
    );
};